/* CocinaBarata - confirmación documental de fabricación a medida, versión CB-2026-11-03 */
(function () {
  'use strict';
  if (window.cbOrderConsentReady) return;
  window.cbOrderConsentReady = true;

  var confirmed = new WeakSet();
  var pending = new WeakSet();
  var orderKey = 'Confirmación productos a medida';
  var version = 'CB-2026-11-03';
  var accepted = 'Sí · CB-2026-11-03 · medidas y especificaciones aceptadas';

  function scopeFor(form) {
    return form.id === 'CartDrawer-Form'
      ? document.querySelector('#CartDrawer')
      : document.querySelector('#main-cart-footer');
  }
  function showError(scope, text) {
    var warning = scope && scope.querySelector('[data-cb-checkout-warning]');
    if (warning) {
      warning.textContent = text;
      warning.hidden = false;
    }
  }
  function clearError(scope) {
    var warning = scope && scope.querySelector('[data-cb-checkout-warning]');
    if (warning) warning.hidden = true;
  }
  function requireConsent(scope) {
    var box = scope && scope.querySelector('[data-cb-order-consent]');
    if (!box) return true;
    if (box.checked) return true;
    var details = box.closest('details');
    if (details) details.open = true;
    showError(scope, 'Para continuar debe revisar las medidas y opciones y marcar la casilla de aceptación de fabricación a medida.');
    try { box.focus({ preventScroll: true }); } catch (e) { box.focus(); }
    box.scrollIntoView({ block: 'center', behavior: 'smooth' });
    return false;
  }
  function endpoint() {
    var base = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/');
    if (base.charAt(base.length - 1) !== '/') base += '/';
    return base + 'cart/update.js';
  }
  function saveConsent() {
    var when = new Date().toISOString();
    var attributes = {};
    attributes[orderKey] = accepted;
    attributes['Condiciones a medida - Versión'] = version;
    attributes['Condiciones a medida - Aceptadas el (UTC)'] = when;
    var marker = '[COCINABARATA · ACEPTACIÓN DEL PEDIDO]';
    var base = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/');
    if (base.charAt(base.length - 1) !== '/') base += '/';
    return fetch(base + 'cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('No se ha podido leer el carrito.');
      return response.json();
    }).then(function (cart) {
      var noteInput = document.querySelector('#Cart-note');
      var currentNote = noteInput ? noteInput.value : (cart.note || '');
      var cleaned = String(currentNote).split(/\r?\n/).filter(function (line) {
        return line.indexOf(marker) !== 0;
      }).join('\n').trim();
      var evidence = marker + ' Aceptación expresa: SÍ | Versión: ' + version +
        ' | Fecha/hora UTC: ' + when +
        ' | Cliente confirma medidas y unidades (mm/cm), cantidades, materiales, grosores, colores, orientación de veta, cantos, composición, bisagras, tiradores y herrajes/opciones aplicables según las líneas del pedido. Art. 103.c RDL 1/2007 solo para bienes realmente personalizados; derechos legales y garantías conservados.';
      var note = (cleaned ? cleaned + '\n\n' : '') + evidence;
      return fetch(endpoint(), {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: attributes, note: note })
      });
    }).then(function (response) {
      if (!response.ok) throw new Error('No se ha podido registrar la aceptación.');
      return response.json();
    }).then(function (cart) {
      if (!cart || !cart.attributes || cart.attributes[orderKey] !== accepted ||
          String(cart.note || '').indexOf(marker) < 0) {
        throw new Error('No se ha podido verificar la aceptación guardada.');
      }
      return cart;
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('#checkout, #CartDrawer-Checkout');
    if (!button || event.defaultPrevented) return;
    var scope = button.closest('#main-cart-footer, #CartDrawer');
    if (!scope || !scope.querySelector('[data-cb-order-consent]')) return;
    if (!requireConsent(scope)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    } else {
      clearError(scope);
    }
  }, true);

  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-cb-order-consent]')) return;
    var scope = event.target.closest('#main-cart-footer, #CartDrawer');
    if (event.target.checked) clearError(scope);
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    var button = event.submitter;
    if (!form || !button || button.name !== 'checkout') return;
    if (form.id !== 'cart' && form.id !== 'CartDrawer-Form') return;
    var scope = scopeFor(form);
    if (!scope || !scope.querySelector('[data-cb-order-consent]')) return;
    if (confirmed.has(form)) {
      confirmed.delete(form);
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    if (!requireConsent(scope) || pending.has(form)) return;
    pending.add(form);
    button.disabled = true;
    showError(scope, 'Guardando la conformidad del pedido...');
    saveConsent().then(function () {
      pending.delete(form);
      button.disabled = false;
      clearError(scope);
      confirmed.add(form);
      form.requestSubmit(button);
    }).catch(function () {
      pending.delete(form);
      button.disabled = false;
      showError(scope, 'No se ha podido registrar su aceptación. Por favor, inténtelo de nuevo antes de pagar.');
    });
  }, true);
})();